export const LONG_TEXT = 'LONG_TEXT'
export const SHORT_TEXT = 'SHORT_TEXT'
export const WHEN_SERVICE = 'WHEN_SERVICE'
export const WHEN_EVENT = 'WHEN_EVENT'
export const MESSAGE = 'MESSAGE'
export const DESCRIPTION = 'DESCRIPTION'
export const PRICE = 'PRICE'
export const INSTANT_LINK = 'INSTANT_LINK'
export const DURATION = 'DURATION'
export const LINK = 'LINK'
export const YES_NO = 'YES_NO'
export const CHOICE = 'CHOICE'
export const SEATS = 'SEATS'
export const LOCATION = 'LOCATION'
export const LOCATION_CHOICE = 'LOCATION_CHOICE'
export const LOCATION_SUGGEST = 'LOCATION_SUGGEST'
export const NEWSLETTER_SUBSCRIBE = 'NEWSLETTER_SUBSCRIBE'
export const INSTANT_NEWSLETTER_SUBSCRIBE = 'INSTANT_NEWSLETTER_SUBSCRIBE'
export const LIVE_CHAT = 'LIVE_CHAT'
export const LIVE_CHAT_WELCOME_MESSAGE = 'LIVE_CHAT_WELCOME_MESSAGE'
export const LIVE_CHAT_AWAY_MESSAGE = 'LIVE_CHAT_AWAY_MESSAGE'
export const LIVE_CHAT_AVAILABILITY = 'LIVE_CHAT_AVAILABILITY'
export const LIVE_CHAT_REQUIRE_USER_INFO = 'LIVE_CHAT_REQUIRE_USER_INFO'
export const MINDBODY = 'MINDBODY'
export const WORKFLOWMAX = 'WORKFLOWMAX'
